// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media only screen and (min-width: 1024px) {\n.app-navigation-toggle {\n\t\tdisplay: none;\n}\n}\n\n", ""]);
// Exports
module.exports = exports;
